var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1.34477e-06 9.44719C0.0786863 9.34545 0.173651 9.20671 0.282185 9.08339C2.61295 6.43196 4.93014 3.75895 7.29889 1.15068C7.6462 0.768385 8.25942 0.45083 8.71255 0.506325C9.12769 0.555654 9.60795 1.07053 9.84673 1.52373C10.1533 2.10952 9.97425 2.77854 9.5374 3.28416C8.58502 4.38173 7.62721 5.47005 6.66669 6.55837C5.82012 7.5172 4.97084 8.47295 4.08358 9.47494C4.27894 9.71233 4.43903 9.9189 4.60997 10.1131C6.20542 11.9321 7.81714 13.7326 9.39902 15.5671C10.3487 16.6708 10.1099 18.163 8.90791 18.4651C8.49005 18.57 7.84156 18.4343 7.55123 18.1137C5.00612 15.305 2.5207 12.4316 0.0162788 9.57668C0.00542506 9.56126 0.0108505 9.52735 0.0027109 9.44719L-1.34477e-06 9.44719Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.58f943200d972be65d969ecee705ff0f.svg";
export { ForwardRef as ReactComponent };